export const categories = [
  { slug: 'wanghong-xiangliao', name: '网红爆料', icon: 'ri-fire-line', description: '网红圈最新鲜的爆料，第一时间掌握网红动态' },
  { slug: 'yule-bagua', name: '娱乐八卦', icon: 'ri-chat-smile-2-line', description: '娱乐圈八卦新闻，明星网红绯闻一网打尽' },
  { slug: 'wanghong-chigua', name: '网红吃瓜', icon: 'ri-emotion-laugh-line', description: '网红吃瓜合集，各种瓜料让你一次吃个够' },
  { slug: 'wanghong-heiliao', name: '网红黑料', icon: 'ri-alert-line', description: '网红黑料曝光，还原真相不遮掩' },
  { slug: 'zhibo-bagua', name: '直播八卦', icon: 'ri-live-line', description: '直播圈八卦，主播故事每日更新' },
  { slug: 'duanqushipin', name: '短视频圈', icon: 'ri-video-line', description: '短视频达人的那些事儿，抖音快手八卦' },
];

export const articles = [
  {
    slug: 'mou-daihuo-wanghong-beizhi-xujia-xuanchuan',
    title: '某千万粉丝带货网红被指虚假宣传，品牌方发声明撇清关系',
    excerpt: '近日，一位拥有超过千万粉丝的带货网红因涉嫌虚假宣传被推上风口浪尖。该网红在直播中声称某护肤品具有"三天美白"的神奇功效...',
    content: `<p>近日，一位拥有超过千万粉丝的带货网红因涉嫌虚假宣传被推上风口浪尖。该网红在直播中声称某护肤品具有"三天美白"的神奇功效，引发大量消费者购买。然而，多位购买者在社交媒体上反映使用后不仅没有美白效果，反而出现皮肤过敏症状。</p>
<p>据知情人士透露，该品牌方已紧急发布声明，表示与该网红的合作关系已经终止，并称"网红在直播中的部分宣传内容未经品牌方审核，属于个人行为"。</p>
<p>这一事件在网络上引发热议，不少网友表示："现在的网红为了赚钱什么都敢说"、"带货主播应该对自己推荐的产品负责"。也有业内人士指出，直播带货行业亟需更严格的监管机制。</p>
<p>截至目前，该网红尚未对此事做出公开回应，其最新一条视频的评论区已经被质疑声淹没。而涉事品牌的相关产品也已在多个电商平台下架处理。</p>
<blockquote><p>据第三方数据平台统计，该网红单场直播销售额曾突破5000万元，位列带货榜前十。此次事件或将对其商业价值造成严重打击。</p></blockquote>`,
    category: 'wanghong-xiangliao',
    imageSeq: 'article-01',
    imagePrompt: 'A modern news studio setting with soft dramatic lighting, a microphone on a desk, abstract red and dark background elements suggesting controversy and media attention, professional photojournalism style, warm tones with subtle crimson accents, editorial composition with depth of field, 4k quality, clean aesthetic',
    author: '爆料君',
    date: '2026-08-03',
    views: 128500,
    tags: ['虚假宣传', '带货网红', '品牌纠纷', '直播翻车'],
    hot: true,
    featured: true,
  },
  {
    slug: 'zhiming-wanghong-qingxu-bengkui-zhibo-jian-leiku',
    title: '知名网红情绪崩溃直播间泪哭，疑似感情问题再度发酵',
    excerpt: '昨晚，某知名网红在直播过程中突然情绪失控落泪，引发粉丝心疼和网友猜测。这已不是该网红第一次在公开场合展露脆弱一面...',
    content: `<p>昨晚10点左右，拥有800万粉丝的知名网红"小橘子"在例行直播中突然情绪崩溃，在镜头前泪流不止，直播被迫中断近20分钟。</p>
<p>据观看直播的粉丝描述，当时小橘子正在和粉丝聊天互动，突然提到"最近真的很累，有些感情上的事情不知道怎么处理"，随后便开始落泪。助理迅速上前安抚并暂时关闭了摄像头。</p>
<p>这一突发状况迅速登上热搜，引发网友广泛讨论。有网友翻出小橘子此前与某男网红的互动记录，猜测两人感情出现裂痕。也有粉丝表示心疼："她一直很努力，希望大家给她一些空间"。</p>
<p>20分钟后，小橘子重新开启直播，向粉丝道歉并表示自己会调整好状态。但对于感情问题的具体细节，她并未做更多说明。</p>`,
    category: 'wanghong-chigua',
    imageSeq: 'article-02',
    imagePrompt: 'A dimly lit streaming room at night with soft ring light glow, emotional atmosphere, modern minimalist decor with warm ambient lighting, professional photography style with shallow depth of field, cinematic mood, gentle bokeh effect, melancholic yet beautiful composition',
    author: '吃瓜小妹',
    date: '2026-08-02',
    views: 96500,
    tags: ['网红直播', '情绪崩溃', '感情八卦', '热搜'],
    hot: true,
    featured: true,
  },
  {
    slug: 'duanqushipin-daren-bei-jubao chaoxi-chuangzuo',
    title: '短视频达人被举报抄袭创作，原创作者晒出时间线证据',
    excerpt: '一场关于短视频内容原创性的争议正在持续发酵。拥有500万粉丝的短视频达人被多名原创作者联合举报...',
    content: `<p>近日，短视频平台上一场关于内容原创性的大讨论正在持续发酵。拥有超过500万粉丝的知名短视频达人"创意小王子"被多位原创作者联合举报，指控其多次抄袭他人创意内容。</p>
<p>据其中一位原创作者"画画的小美"透露，她于今年6月发布的一支手绘教程视频的创意、分镜和文案被"创意小王子"在7月的视频中几乎原封不动地照搬，而对方并未标注任何灵感来源或给予credit。</p>
<p>"画画的小美"在社交媒体上晒出了详细的时间线对比截图，两条视频的相似度令人震惊。随后，又有三四位原创作者站出来分享了自己的类似遭遇。</p>
<p>面对质疑，"创意小王子"在最新视频中回应称"创作灵感来源于生活，相似并非抄袭"，但这一说法并未平息争议，反而让更多网友加入讨论。该事件也引发了关于短视频平台应该如何保护原创内容的大讨论。</p>`,
    category: 'duanqushipin',
    imageSeq: 'article-03',
    imagePrompt: 'A creative studio workspace with multiple screens showing video editing timelines, warm ambient lighting, modern clean design, professional content creation environment, soft shadows, editorial photography style, neutral tones with subtle warm accents, high detail',
    author: '八卦雷达',
    date: '2026-08-01',
    views: 78200,
    tags: ['短视频', '抄袭争议', '原创保护', '内容创作'],
    hot: true,
  },
  {
    slug: 'zhubo-zhibo-jian-baoli-yanyu-bei-pingtai-jinyan',
    title: '某主播直播间暴力言语被平台禁言30天，粉丝群起抗议',
    excerpt: '一位拥有300万粉丝的游戏主播因在直播中使用暴力威胁性语言，被平台处以禁言30天的处罚，引发粉丝强烈不满...',
    content: `<p>知名游戏主播"狂风"因在最近一场直播中对其他玩家使用了暴力威胁性语言，被直播平台处以禁言30天的严厉处罚。这是该平台今年以来对头部主播开出的最重罚单之一。</p>
<p>据平台官方公告，狂风在直播过程中多次使用不当言辞攻击他人，违反了平台社区公约中的"文明直播"条款。平台在收到多名用户举报后，经过审核确认违规事实，随即做出禁言处理。</p>
<p>然而，这一决定引发了狂风粉丝群体的强烈不满。大量粉丝在社交媒体上发起"#解封狂风#"的话题讨论，认为"主播只是心直口快"、"游戏圈子里的玩笑话不能太当真"。目前该话题阅读量已超过2000万。</p>
<p>但也有不少网友支持平台的处理决定："公众人物更应该注意自己的言行"、"主播不是法外之地"。平台方面则表示将坚持原则，不会因为粉丝施压而改变处罚决定。</p>`,
    category: 'zhibo-bagua',
    imageSeq: 'article-04',
    imagePrompt: 'A gaming streaming setup with RGB lighting and multiple monitors, dramatic contrast between neon lights and dark background, professional esports photography style, intense atmosphere, modern gaming gear, cinematic composition with moody lighting, high detail',
    author: '爆料君',
    date: '2026-08-01',
    views: 85300,
    tags: ['游戏主播', '禁言处罚', '直播平台', '粉丝争议'],
    hot: false,
  },
  {
    slug: 'yulequan-dingliu-yuanyi-bei-chuiguo-toufu-shui',
    title: '娱乐圈顶流艺人被曝偷税漏税，工作室凌晨紧急回应',
    excerpt: '今日凌晨，一份疑似涉及娱乐圈顶流艺人的税务稽查文件在网络上泄露，引发轩然大波...',
    content: `<p>今日凌晨2点，一份疑似涉及娱乐圈某顶流艺人的税务稽查文件在社交媒体上被广泛传播。文件显示该艺人涉嫌通过"阴阳合同"等方式偷逃税款，涉及金额高达数千万元。</p>
<p>消息一经传出，立刻引爆网络。该艺人的名字迅速登上各大平台热搜榜首。大量网友涌入其工作室官方账号留言追问真相。</p>
<p>凌晨4点，该艺人工作室发布紧急声明，称网传文件"纯属捏造，已委托律师取证并将追究造谣者法律责任"。声明还强调该艺人"一直严格遵守国家法律法规，依法纳税"。</p>
<p>然而，一位自称"前业内人员"的网友在评论区爆料称，娱乐圈的高收入群体普遍存在税务筹划问题，并暗示"这只是冰山一角"。这一言论再次引发公众对娱乐圈税务问题的广泛关注和讨论。</p>`,
    category: 'yule-bagua',
    imageSeq: 'article-05',
    imagePrompt: 'A luxurious entertainment industry setting at night, city skyline through floor-to-ceiling windows, dramatic noir lighting, mysterious and investigative atmosphere, professional photography, cool shadows with warm amber accent lights, cinematic mood, high contrast',
    author: '吃瓜小妹',
    date: '2026-07-31',
    views: 215000,
    tags: ['娱乐圈', '税务问题', '顶流艺人', '工作室声明'],
    hot: true,
    featured: true,
  },
  {
    slug: 'wanghong-qinglv-fenshou-huxiang-jie-duan',
    title: '网红情侣官宣分手，双方互揭老底引发粉丝站队大战',
    excerpt: '曾经被粉丝称为"神仙眷侣"的一对网红情侣正式官宣分手，然而双方的"分手文案"却充满了火药味...',
    content: `<p>被粉丝们亲切称为"小甜饼CP"的网红情侣"阿杰"和"小雨"今天中午同时发布长文，正式官宣分手。然而与常见的"和平分手"不同，两人的分手声明充满了暗讽和指责，瞬间引爆了社交平台。</p>
<p>阿杰在声明中写道："有些人表面上温柔体贴，背地里的心机让人不寒而栗。"而小雨则回应称："两年真心付出换来的却是无休止的猜疑和控制，我受够了。"双方各执一词，让原本支持这对CP的粉丝陷入了两难。</p>
<p>更令人关注的是，两人的粉丝群体迅速分裂为两大阵营，在评论区展开了激烈的"站队大战"。有网友感叹："比看电视剧还精彩"、"网红的分手比恋情更吸粉"。目前相关话题阅读量已突破3亿。</p>`,
    category: 'wanghong-chigua',
    imageSeq: 'article-06',
    imagePrompt: 'A dramatic split composition with warm and cool color contrast, symbolic heart-shaped neon light breaking apart, moody cinematic lighting, modern urban setting at twilight, emotional storytelling through visual metaphor, editorial photography, soft focus background',
    author: '八卦雷达',
    date: '2026-07-30',
    views: 186000,
    tags: ['网红情侣', '分手', '粉丝站队', '热搜'],
    hot: true,
    featured: true,
  },
  {
    slug: 'mou-wanghong-bei-baochu-duonian-qian-zhaopian',
    title: '某网红被曝出多年前旧照，网友惊呼"换了个人"',
    excerpt: '一组据称是某当红网红多年旧照在网络上疯传，照片中的形象与如今判若两人，引发整容质疑...',
    content: `<p>今天上午，一组据称是某当红美妆网红"莉莉酱"多年前的旧照在网络上被大量转发。照片中的莉莉酱与如今在镜头前光鲜亮丽的形象判若两人，引发了网友对其是否整容的热烈讨论。</p>
<p>从流传的旧照来看，早期的莉莉酱面部轮廓、五官比例与现在有明显差异。有网友专门制作了对比图，标注了鼻子、下巴、眼睛等多个部位的疑似变化点。</p>
<p>面对铺天盖地的质疑，莉莉酱在下午的直播中坦然回应："每个人都在成长和变化，我确实做过一些微调，这没有什么好隐瞒的。重要的是现在的我活成了自己喜欢的样子。"这一真诚回应反而赢得了不少网友的好感。</p>`,
    category: 'wanghong-heiliao',
    imageSeq: 'article-07',
    imagePrompt: 'A clean beauty studio with professional makeup lighting, mirror reflection showing transformation concept, elegant and sophisticated atmosphere, soft natural light combined with ring light, modern minimalist interior, editorial beauty photography, warm neutral tones',
    author: '爆料君',
    date: '2026-07-29',
    views: 143000,
    tags: ['网红旧照', '整容质疑', '美妆网红', '形象变化'],
    hot: false,
  },
  {
    slug: 'zhibopingtai-neibu-shuju-xielou-shijian',
    title: '直播平台内部数据泄露，多位大主播真实观看人数曝光',
    excerpt: '一份疑似某主流直播平台的内部运营数据在技术论坛泄露，多位知名大主播的真实观看人数与前台显示存在巨大差距...',
    content: `<p>今日，一份疑似来自某主流直播平台的内部运营数据在匿名技术论坛上被曝光。数据显示，多位粉丝数百万的头部主播，其真实的同时在线观看人数远低于前台显示的数字，差距最高可达10倍以上。</p>
<p>根据泄露的数据表格，某位自称拥有300万粉丝的主播，在高峰时段的真实观看人数仅为2万人左右，而前台显示的"人气值"却高达200万。另一位以"人气王"著称的主播，真实观看人数甚至不如一些腰部主播。</p>
<p>这份数据的流出让直播行业的"注水"问题再次成为公众焦点。有行业分析师指出："直播平台的数据泡沫早已不是秘密，但这次的泄露让问题变得更加直观。"</p>
<p>截至目前，涉事直播平台尚未对此事做出官方回应。但据内部人士透露，平台正在紧急排查数据泄露源头。</p>`,
    category: 'zhibo-bagua',
    imageSeq: 'article-08',
    imagePrompt: 'A dark server room with glowing data screens showing analytics charts and numbers, cyber-security breach concept, dramatic blue and red lighting contrast, high-tech atmosphere, professional hacker documentary style, mysterious and intense mood, editorial composition',
    author: '吃瓜小妹',
    date: '2026-07-28',
    views: 167000,
    tags: ['数据泄露', '直播平台', '观看人数', '注水'],
    hot: true,
  },
  {
    slug: 'mcn-jigou-yayi-zhubojie-yue-yinqi-zhongyi',
    title: 'MCN机构"霸王条款"压榨主播引争议，多名签约主播集体解约',
    excerpt: '某头部MCN机构被爆出存在严重的合同不公平问题，多名签约主播联合发声控诉...',
    content: `<p>近日，某头部MCN机构因涉嫌使用"霸王条款"压榨签约主播而陷入舆论漩涡。据多位在该机构签约的主播反映，合同中的分成比例、解约条件、竞业限制等条款存在严重的不公平问题。</p>
<p>一位化名"小C"的主播向媒体透露，其合同规定前两年的直播收益分成仅为2:8（主播拿2成），而解约需要支付高达500万元的违约金。"如果不签这份合同，MCN就不给任何流量扶持，等于在这个行业没法生存。"</p>
<p>截至目前，已有超过20名签约主播宣布与该MCN机构解除合约，并准备通过法律途径维权。此事也引发了业界对MCN行业规范化的广泛讨论。多位法律专家表示，平台和MCN机构之间的利益分配机制亟需建立更透明的行业标准。</p>`,
    category: 'wanghong-heiliao',
    imageSeq: 'article-09',
    imagePrompt: 'A modern corporate office with dramatic shadows, contract papers scattered on a glass desk, conflict and tension atmosphere, professional legal documentary style, high contrast lighting through blinds, cinematic composition, serious and investigative mood',
    author: '八卦雷达',
    date: '2026-07-27',
    views: 92000,
    tags: ['MCN机构', '霸王条款', '主播维权', '行业规范'],
    hot: false,
  },
  {
    slug: 'wanghong-canju-kaidian-bei-zhi-shoushi-buwei-sheng',
    title: '网红餐厅开业被指后厨不卫生，执法人员突击检查发现多项违规',
    excerpt: '某网红跨界开设的餐厅开业仅一个月，就因后厨卫生问题被顾客举报，执法人员突击检查后发现问题重重...',
    content: `<p>由知名美食网红"大嘴哥"跨界开设的网红餐厅"嘴哥食堂"开业仅一个月，就因食品安全问题被推上风口浪尖。多名顾客在消费后出现腹泻等症状，并在社交平台发布了后厨环境存疑的照片。</p>
<p>当地市场监管部门接到举报后进行了突击检查。检查结果显示，该餐厅存在食材存放不当、从业人员健康证不全、餐具消毒不规范等多项违规问题。执法人员当场下达了整改通知书，责令限期整改。</p>
<p>"大嘴哥"随后发布道歉视频，承认在餐厅管理上存在疏忽，"身为美食博主却让自己的餐厅出现这样的问题，我深感惭愧。"他表示将暂时关闭餐厅进行全面整改，并承担所有身体不适顾客的医疗费用。</p>`,
    category: 'wanghong-xiangliao',
    imageSeq: 'article-10',
    imagePrompt: 'A commercial kitchen inspection scene with health department officials, stainless steel counters under harsh fluorescent lighting, documentary style photography, tense atmosphere, food safety concept, clean composition with subtle tension, professional reportage style',
    author: '爆料君',
    date: '2026-07-26',
    views: 105000,
    tags: ['网红餐厅', '食品安全', '突击检查', '网红翻车'],
    hot: false,
  },
  {
    slug: 'duanqushipin-pingtai-suanfa-bianhua',
    title: '短视频平台算法大调整，多位头部达人流量腰斩引恐慌',
    excerpt: '某短视频平台近期进行了重大算法调整，多位千万级粉丝达人的视频播放量出现断崖式下跌...',
    content: `<p>某头部短视频平台近期的算法调整在创作者圈内引发了不小的震动。据多位创作者反映，自上周起，他们的视频播放量出现了断崖式下跌，一些拥有千万粉丝的头部达人甚至遭遇了"流量腰斩"。</p>
<p>一位不愿具名的MCN运营负责人表示："我们旗下十几个账号的流量都受到了影响，最严重的下降了70%。平台似乎在把流量向新创作者和中腰部倾斜，这对头部的商业变现造成了很大冲击。"</p>
<p>平台方面回应称，此次算法调整旨在"让更多优质内容被看见，打破流量马太效应"，但多数受影响的达人对此并不买账。有达人抱怨："辛辛苦苦积累的粉丝基础说没就没了，平台的规则说变就变，创作者完全没有安全感。"</p>`,
    category: 'duanqushipin',
    imageSeq: 'article-11',
    imagePrompt: 'A futuristic digital data visualization showing declining charts and algorithm patterns, abstract technology concept, sleek modern design, cool and warm color contrast, data journalism aesthetic, clean lines and glowing elements, professional tech photography',
    author: '吃瓜小妹',
    date: '2026-07-25',
    views: 78000,
    tags: ['算法调整', '流量下降', '短视频平台', '内容创作'],
    hot: false,
  },
  {
    slug: 'yulequan-mouxian-yanyuan-bei-pai-dao-yemi',
    title: '娱乐圈某一线演员被拍到夜会神秘女子，经纪人回应是"工作聚餐"',
    excerpt: '有媒体拍到某已婚一线男演员深夜与一名神秘女子共进晚餐后一同离开，引发婚变猜测...',
    content: `<p>昨日晚间，某知名娱乐媒体拍到已婚一线男演员"陈sir"与一名神秘女子在某高档餐厅共进晚餐。两人在餐厅内举止亲密，用餐结束后一同乘车离开，直到深夜才分别返回各自住处。</p>
<p>这组照片一经发布就引发了网友热议。陈sir与妻子结婚五年，一直以"娱乐圈模范夫妻"的形象示人。此次被拍到夜会神秘女子，让众多粉丝感到震惊和失望。</p>
<p>今早，陈sir的经纪团队紧急回应称："当晚是与多位剧组同事一起讨论新项目的工作聚餐，并非只有两人。网传照片存在恶意剪辑和断章取义的情况。"经纪人还表示将保留追究造谣者法律责任的权利。但其妻子方面尚未做出任何回应。</p>`,
    category: 'yule-bagua',
    imageSeq: 'article-12',
    imagePrompt: 'A high-end restaurant exterior at night with paparazzi photography style, blurred background lights creating bokeh effect, mysterious and secretive atmosphere, urban night scene, cinematic voyeur style, dark tones with warm interior light leaking through windows, dramatic tension',
    author: '八卦雷达',
    date: '2026-07-24',
    views: 223000,
    tags: ['一线演员', '夜会', '婚变猜测', '经纪人回应'],
    hot: true,
  },
];

export const getArticlesByCategory = (slug: string) => articles.filter(a => a.category === slug);

export const getArticleBySlug = (slug: string) => articles.find(a => a.slug === slug);

export const getHotArticles = () => articles.filter(a => a.hot).slice(0, 5);

export const getFeaturedArticles = () => articles.filter(a => a.featured);

export const getRelatedArticles = (currentSlug: string, category: string, count = 3) =>
  articles.filter(a => a.slug !== currentSlug && a.category === category).slice(0, count);

export const getLatestArticles = (count = 6) =>
  [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);